import { SxProps } from '@mui/material'
import StylesLayoutServiceInterface from '~/src/components/layout/styles/StylesLayoutServiceInterface'
import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'

export default class StylesLayoutServiceStyleTwo extends TemplateServiceStyleBase implements StylesLayoutServiceInterface {
  public getContainerSx(): SxProps {
    const hasHeader: boolean = this.layout?.header.display ?? false
    const hasSubHeader: boolean = this.layout?.subHeader.display ?? false
    const hasMainSideBar: boolean = this.layout?.mainSideBar.display ?? false
    const hasFooter: boolean = this.layout?.footer.display ?? false
    const hasMobileNavigation: boolean = this.layout?.mobileNavigation.display ?? false
    const headerRow = hasMainSideBar ? '"header header"' : '"header"'
    const subHeaderRow = hasMainSideBar ? '"sub-header main-sidebar"' : '"sub-header"'

    return {
      minHeight: '100vh',
      display: 'grid',
      gridTemplateColumns: `${hasMainSideBar ? 'minmax(0, 1fr) minmax(500px, 35vw)' : 'minmax(0, 1fr)'}`,
      gridTemplateRows: '' +
        `${hasHeader ? 'max-content' : ''} ` +
        `${hasSubHeader ? 'max-content' : ''} ` +
        '1fr ' +
        `${hasFooter ? 'max-content' : ''}`,
      gridTemplateAreas: '' +
        `${hasHeader ? headerRow : ''} ` +
        `${hasSubHeader ? subHeaderRow : ''} ` +
        `${hasMainSideBar ? '"main main-sidebar"' : '"main"'} ` +
        `${hasFooter ? '"footer footer"' : ''} `,
      [this.muiTheme.breakpoints.down('md')]: {
        gridTemplateAreas: `
         ${hasHeader ? '"header"' : ''}
         ${hasSubHeader ? '"sub-header"' : ''}
         "main"
         ${hasFooter ? '"footer"' : ''}
         ${hasMobileNavigation ? '"mobile-navigation"' : ''}
        `,
        gridTemplateColumns: '100%',
        gridTemplateRows: `
         ${hasHeader ? 'max-content ' : ''}
         ${hasSubHeader ? 'max-content ' : ''}
         1fr
         ${hasFooter ? 'max-content' : ''}
         ${hasMobileNavigation ? 'max-content' : ''}
        `
      }
    }
  }

  public getMainSx(isLocatorPage?: boolean): SxProps {
    const hasMainSideBar = !!this.layout?.mainSideBar.display

    const getPr = (): number => {
      if (isLocatorPage) {
        return 0
      }

      return hasMainSideBar ? 2 : 12
    }

    return {
      px: isLocatorPage ? 0 : 12,
      pr: getPr(),
      overflow: isLocatorPage ? 'hidden' : undefined,
      [this.muiTheme.breakpoints.down('md')]: {
        px: 0
      }
    }
  }

  public getFooterSx(): SxProps {
    return {
      backgroundColor: 'background.main',
      color: 'background.contrastText',
      width: '100%',
      position: 'sticky',
      bottom: 0,
      zIndex: 2
    }
  }
}
